import {useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {Helmet} from "react-helmet";
import {Spinner, TitlePage} from "../../../shared";
import {getCachedImageUrl, isMobileDevice} from "../../../../utils/utils";
import LiveHlsPlayer from "../../squadflixVideoView/liveHlsPlayer/LiveHlsPlayer";
import {VlcUtils} from "../utils/vlcUtils";
import ItemsHorizontalScroll from "../../shared/itemsHorizontalScroll/itemsHorizontalScroll";
import {EventLink, LeagueEvent} from "../../../../apis/towers-sports-api/types";
import CachedImage from "../../../shared/cached-image/cached-image";
import {TowersSportsApi} from "../../../../apis/towers-sports-api/towers-sports-api";
import ItemBackdropDetails from "../../shared/item-backdrop-details/item-backdrop-details";
import LiveStreamPlayer from "../../squadflixVideoView/liveStreamPlayer/liveStreamPlayer";
import ButtonV2 from "../../../shared/button-v2/button-v2";

const hlsUrl = "https://torresowo.myftp.org:9994/hls/manifest.m3u8?id=STREAM_ID";
const streamUrl = "https://torresowo.myftp.org:9994/hls/streamAceLink?id=STREAM_ID"

const LiveEventDetails = () => {

    const id = useParams().eventId;
    const option = useParams().option;
    console.log("Rendering LiveAcestreamPlayer for id:", id, "option:", option);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [event, setEvent] = useState<LeagueEvent>(null);
    const [selectedUrl, setSelectedUrl] = useState<EventLink>(null);
    const [streamMode, setStreamMode] = useState("stream");

    useEffect(() => {
        TowersSportsApi.getEvent(id).then((response) => {
            setEvent(response.event);
        }).catch(() => {
            setEvent(null);
        }).finally(() => {
            setLoading(false);
        });
    }, [id]);

    useEffect(() => {
        if (event?.acestreamEvent?.enlaces?.length > 0) {
            let selected = event.acestreamEvent.enlaces[0];
            if (option) {
                const found = event.acestreamEvent.enlaces[option];
                if (found) {
                    selected = found;
                }
            }
            setSelectedUrl({
                name: selected.name,
                url: selected.url.replace("acestream://", "")
            });
        }
    }, [event, option]);

    if (loading) {
        return (
            <div className="d-flex flex-column align-items-center justify-content-center text-center mt-5">
                <Spinner className="spinner-sm"/>
            </div>
        );
    }

    if (!event || !selectedUrl) {
        return (
            <div className="d-flex flex-column align-items-center justify-content-center text-center mt-5">
                <h3>Evento no encontrado</h3>
            </div>
        );
    }

    const otherStreams = () => {
        return <ItemsHorizontalScroll>
            {
                event.acestreamEvent.enlaces.map((link, index) => {
                    if (index === Number(option)) return null;

                    return <div key={link.url}>
                        <ItemBackdropDetails
                            onClickPoster={() => {
                                navigate(`/squadflix/live-event/${id}/${index}`);
                            }}
                            onClickDetails={() => {
                                navigate(`/squadflix/live-event/${id}/${index}`);
                            }}
                            style={{
                                width: "min(300px, 59vw)",
                                position: "relative",
                            }}
                            overlay={{
                                center: <i className="fa-solid fa-play fa-xl" style={{
                                    padding: "10px 7px",
                                }}></i>
                            }}
                            cachedSrc={event.strThumb}
                            detailsSubtitle={event.strEvent}
                            detailsTitle={link.name}
                        />
                    </div>
                })
            }
        </ItemsHorizontalScroll>
    }

    return (
        <div>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>Live | {event.strEvent}</title>
                <link rel="icon"
                      href={getCachedImageUrl("https://play-lh.googleusercontent.com/daJbjIyFdJ_pMOseXNyfZuy2mKOskuelsyUyj6AcGb0rV0sJS580ViqOTcSi-A1BUnI")}/>
            </Helmet>
            <TitlePage leftClass="col-10" icon=""
                       rightClass="col-2"
                       rightOptions={<i className="fa-solid fa-xmark text-light fa-xl p-3" style={{
                           cursor: "pointer"
                       }} onClick={() => {
                           navigate("/squadflix/live");
                       }}></i>}
                       title={<div className="d-flex flex-row align-items-center">
                           <CachedImage style={{height: '3rem', borderRadius: '8px'}}
                                        src={event.strThumb}/>
                           <span className="ps-2">
                    {event.strEvent}
                </span>
                       </div>} titleClass={undefined} disableScroll={true} hideSeparator={undefined}
                       fixedHeight={undefined} className={undefined} style={undefined}></TitlePage>
            {streamMode === "hls" && <LiveHlsPlayer
                showDebugInfo={!isMobileDevice()}
                title={selectedUrl.name}
                className="ace-stream-video-player"
                autoPlay={true} muted={false}
                src={hlsUrl.replace("STREAM_ID", selectedUrl.url)}
                poster={undefined} hlsConfig={undefined} onStatusChange={undefined}/>}
            {streamMode === "stream" && <LiveStreamPlayer
                title={selectedUrl.name}
                className="ace-stream-video-player"
                autoPlay={true}
                otherStreams={otherStreams()}
                src={streamUrl.replace("STREAM_ID", selectedUrl.url)}/>
            }
            <div className="d-flex flex-row justify-content-end gap-3 pt-3 pb-3">
                <ButtonV2 size="small" onClick={() => {
                    if (streamMode === "hls") {
                        setStreamMode("stream");
                    } else {
                        setStreamMode("hls");
                    }
                }}>
                    {streamMode === "hls" &&
                        <span><i className="fa-solid fa-arrows-to-dot fa-lg"></i> Usar Stream</span>}
                    {streamMode === "stream" && <span><i className="fa-solid fa-wave-square fa-lg"></i> Usar HLS</span>}
                </ButtonV2>
                <button
                    className="hlsbtn hlsbtn--vlc"
                    onClick={e => {
                        if (streamMode === "hls") {
                            VlcUtils.openInVlc(e, hlsUrl.replace("STREAM_ID", selectedUrl.url))
                        } else {
                            VlcUtils.openInVlc(e, streamUrl.replace("STREAM_ID", selectedUrl.url))
                        }
                    }}
                    title="Abrir en VLC"
                    aria-label="Abrir en reproductor VLC externo"
                >
                    <img src="https://cdn-icons-png.flaticon.com/512/732/732256.png" alt="vlc"
                         style={{maxWidth: "70%"}}/>
                </button>
            </div>
            <hr/>
            <TitlePage icon="fa-solid fa-link" title={"Otros enlaces"} hideSeparator={true}
                       rightOptions={undefined} titleClass={undefined} leftClass={undefined} rightClass={undefined}
                       disableScroll={true} fixedHeight={undefined} className={undefined}
                       style={undefined}></TitlePage>
            <div className="pt-2">
                {otherStreams()}
            </div>
        </div>
    )
}

export default LiveEventDetails;
